/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserData } from '../../interfaces/common/users';
import { UsersService } from './services/users.service';
import { UsersApi } from './api/users.api';
import { HttpService } from './api/http.service';
import { CountryData } from '../../interfaces/common/countries';
import { CountryData as countriesMst } from '../../interfaces/masters/country';
import { CountriesService } from './services/countries.service';
import { CountriesApi } from './api/countries.api';
import { SettingsApi } from './api/settings.api';
import { NbAuthModule } from '@nebular/auth';
import { SettingsData } from '../../interfaces/common/settings';
import { SettingsService } from './services/settings.service';
import { DepartmentService } from './services/department.service';
import { DepartmentData } from '../../interfaces/masters/department';
import { DepartmentApi } from './api/department.api';
import { CountryApi } from './api/countriesMst.api';
import { StateApi } from './api/state.api';
import { DistrictApi } from './api/district.api';
import { CouncilApi } from './api/councils.api';
import { CouncilService } from './services/council.service';
import { DesignationService } from './services/designation.service';
import { DesignationtData } from '../../interfaces/masters/designations';
import { DesignationApi } from './api/designation.api';
import { UsertypeService } from './services/usertype.service';
import { UsertypeData } from '../../interfaces/masters/usertype';
import { UsertypeApi } from './api/usertype.api';
import { StateData } from '../../interfaces/masters/state';
import { PayersService } from './services/payers.service';
import { PayersData } from '../../interfaces/masters/payers';
import { PayersApi } from './api/payers.api';
import { InsuranceService } from './services/insurance.service';
import { InsuranceData } from '../../interfaces/masters/insurance';
import { CouncilData } from '../../interfaces/masters/council';
import { InsuranceApi } from './api/insurance.api';
import { CountryMstService } from './services/countriesMst.service';
import { StateMstService } from './services/state.service';
import{InstitutionsData} from '../../interfaces/masters/institutions';
import {InstitutionsApi} from './api/institutions.api';
import{InstitutionsService} from './services/institutions.service';
import { CustomerService } from './services/customer.service';
import { CustomerData } from '../../interfaces/masters/customer';
import { CustomerApi } from './api/customer.api';
// import{ItemQualityCheckListData} from '../../interfaces/masters/itemQualityCheckList';
// import {ItemQualityCheckListApi} from './api/itemQualityCheckList.api';
// import {ItemQualityCheckListService } from   './services/itemQualityCheckList.service';

import{SupplierPaymentData} from '../../interfaces/masters/supplierpayment';
import {SupplierPaymentApi} from './api/supplierpayment.api';
import {SupplierPaymentService } from   './services/supplierpayment.service';


import { ImplantData } from '../../interfaces/masters/implant';
import { ImplantApi } from './api/implant.api';
import { ImplantService } from './services/implant.service';

import { ReferralSettlementData } from '../../interfaces/masters/referralsettlement';
import { ReferralSettlementApi } from './api/referralSettlement.api';
import { ReferralSettlementService } from './services/referralSettlement.service';

import { WardBasedDefaultServiceData } from '../../interfaces/masters/Ward-Based-Default-Service';
import { WardBasedDefaultServiceApi } from './api/wardbaseddefaultservice.api';
import { WardBasedDefaultServcService } from './services/WardBasedDefaultService.service';

import { BloodIndentRequestHeaderData } from './../../../pages/blood-bank/backend/interface/bloodIndentRequestHeader';
import { BloodIndentRequestDetailsData } from './../../../pages/blood-bank/backend/interface/BloodIndentRequestDetails';

import{MandatoryTemplateData} from '../../interfaces/masters/mandatory-template';
import {MandatoryTemplateApi} from './api/mandatory-template.api';
import{MandatoryTemplateService} from './services/mandatory-template.service';
import{PaymentData} from '../../interfaces/masters/payment';
import {PaymentApi} from './api/payment.api';
import{PaymentService} from './services/payment.service';
import{QualificationsData} from '../../interfaces/masters/qualifications';
import {QualificationsApi} from './api/qualifications.api';
import{QualificationsService} from './services/qualifications.service';
import{LaundryRecDetailData} from '../../interfaces/masters/laundryrecdetail';
import {LaundryRecDetailApi } from './api/laundryrecdetail.api';
import{LaundryRecDetailService} from './services/laundryrecdetail.service';
import{AssetTypeData} from '../../interfaces/masters/assetType';
import {AssetTypeApi } from './api/assetType.api';
import{AssetTypeService} from './services/assetType.service';
import{ShiftMstData} from '../../interfaces/masters/shiftmst';
import {ShiftMstApi } from './api/shiftmst.api';
import{ShiftMstService} from './services/shiftmst.service';
import{CustomerTypeData} from '../../interfaces/masters/customertype';
import {CustomerTypeApi } from './api/customertype.api';
import{CustomerTypeService} from './services/customertype.service';
import { HsnSacApi } from './api/hsnsac.api';
import { HsnSacData } from '../../interfaces/masters/hsn-sac' ;
import{HsnSacService} from './services/hsnsac.service';
import{AccreditationData} from '../../interfaces/masters/accreditation';
import {AccreditationApi} from './api/accreditation.api';
import{AccreditationService} from './services/accreditation.service';
import{LaundryIssuedData} from '../../interfaces/masters/laundryissued';
import {LaundryIssuedApi} from './api/laundryissued.api';
import{LaundryIssuedService} from './services/laundryissued.service';
import{LaundryItemData} from '../../interfaces/masters/laundryitem';
import {LaundryItemApi} from './api/laundryitem.api';
import{LaundryItemService} from './services/laundryitem.service';
import { DistrictMstService } from './services/districts.service';
import { DistrictData } from '../../interfaces/masters/district';
import { ExpenseData } from '../../interfaces/masters/expense';
import { ExpenseService } from './services/expense.service';
import { ExpenseApi } from './api/expenses.api';
import { ReferralData } from '../../interfaces/masters/referral';
import { ReferralService } from './services/referral.service';
import { ReferralApi } from './api/referrals.api';
import { ServiceData } from '../../interfaces/masters/service';
import { ServiceService } from './services/service.service';
import { ServiceApi } from './api/service.api';
import { EmployeeData } from '../../interfaces/masters/employee';
import { EmployeeService } from './services/employee.service';
import { EmployeeApi } from './api/employee.api';

import { BankApi } from './api/bank.api';
import { BankData } from '../../interfaces/masters/bank';
import { BankService } from './services/bank.service';
import { DiagnosisService } from './services/diagnosis.service';
import { DiagnosisData } from '../../interfaces/masters/diagnosis';
import { DiagnosisApi } from './api/diagnosis.api';

import { FamilLinkData } from '../../interfaces/patient-services/family-link';
import { FamilyLinkService } from './services/familyLink.service';
import { FamilyLinkApi } from './api/familyLink.api';


import { HospitalSettingsService } from './services/hospitalsettings.service';
import { HospitalSettingsData } from '../../interfaces/masters/hospitalsettings';
import { HospitalSettingsApi } from './api/hospitalsettings.api';

import { TenantService } from './services/tenant.service';
import {TenantApi} from './api/tenant.api';
import {TenantData} from '../../interfaces/masters/tenant';


import { PatientWalletService } from './services/patient-wallet.service';
import {PatientWalletApi} from './api/patientwallet.api';
import {PatientWalletData} from '../../interfaces/patient-services/patient-wallet';

import { TenantModuleApi } from './api/tenantmodule.api';
import { TenantModuleData } from '../../interfaces/masters/tenantmodule';
import { TenantModuleService } from './services/tenantmodule.service';
import{TenantBranchData} from '../../interfaces/masters/tenantbranch';
import {TenantBranchApi} from './api/tenantbranch.api';
import{TenantBranchService} from './services/tenantbranch.service';
import { PhysicianMstService } from './services/physician-mst.service';
import { PhysicianData } from '../../interfaces/masters/physician-mst';
import { PhysicianApi } from './api/physician-mst.api';
import{ChiefComplaintsData} from '../../interfaces/masters/chiefcomplaint';
import {ChiefComplaintsApi} from './api/chiefcomplaint.api';
import{ChiefComplaintsService} from './services/chiefcomplaint.service';
import { LanguagesData } from '../../interfaces/masters/languages';
import { LanguagesService } from './services/languages.service';
import { InstructionApi } from './api/instruction.api';
import { InstructionData } from '../../interfaces/masters/instruction';
import { InstructionService } from './services/instruction.service';
import { LanguagesApi } from './api/languages.api';
import { PatientRegistrationApi } from './api/patient-registration.api';
import { PatientRegistrationMstService } from './services/patient-registration.service';
import { PatientRegistrationData } from '../../interfaces/patient-services/patient-registration';
import { ServiceCategoryApi } from './api/servicecategory.api';
import {ServiceCategoryData } from '../../interfaces/masters/servicecategory';
import { ServiceCategoryService } from './services/servicecategory.service';
import {UnitMstApi } from './api/unitmst.api';
import {UnitMstData } from '../../interfaces/masters/unitmst';
import { UnitMstService } from './services/unitmst.service';
import { PatientPayerApi } from './api/patient-payers';
import { PatientPayerData } from '../../interfaces/patient-services/patient-payer';
import { PatientPayerMstService } from './services/patient-payer.service';


import {GenericApi } from './api/generic.api';
import {GenericData } from '../../interfaces/masters/generic';
import { GenericService } from './services/generic.service';

import {MedicineManufacturersApi } from './api/medicinemanufacturer.api';
import {MedicineManufacturersData } from '../../interfaces/masters/medicinemanufacturer';
import { MedicineManufacturersService } from './services/medicinemanufacturer.service';

import {MedicineApi } from './api/medicine.api';
import {MedicineData } from '../../interfaces/masters/medicine';
import { MedicineService } from './services/medicine.service';

import {TenantMasterPackageApi } from './api/tenantMasterPackage.api';
import {TenantMasterPackageData } from '../../interfaces/masters/tenantMasterPackage';
import { TenantMasterPackageService } from './services/TenantMasterPackage.service';

import { MedicineCategoryApi } from './api/medicinecategory.api';
import {MedicineCategoryData } from '../../interfaces/masters/medicinecategory';
import { MedicineCategoryService } from './services/medicinecategory.service';
import { LabCategoryApi } from './api/labcategory.api';
import {LabCategoryData } from '../../interfaces/masters/labcategory';
import { LabCategoryService } from './services/labcategory.service';
import { ExaminationData } from '../../interfaces/masters/examination';
import { ExaminationService } from './services/examination.service';
import { ExaminationApi } from './api/examination.api';
import { ProcedureData } from '../../interfaces/masters/procedure';
import { ProcedureService } from './services/procedure.service';
import { ProcedureApi } from './api/procedure.api';
import { SupplierData } from '../../interfaces/masters/supplier';
import { SupplierService } from './services/supplier.service';
import { SupplierApi } from './api/supplier.api';
import { SalesManData } from '../../interfaces/masters/salesman';
import { SalesManService } from './services/salesman.service';
import { SalesManApi } from './api/salesman.api';
import { LabCultureHeaderData } from '../../interfaces/masters/labcultureheader';
import { LabCultureHeaderService } from './services/labcultureheader.service';
import { LabCultureHeaderApi } from './api/labcultureheader.api';
import {StorageShelfApi } from './api/storageshelf.api';
import {StorageShelfData } from '../../interfaces/masters/storageshelf';
import { StorageshelfService } from './services/storageshelf.service';
import {DietPlanApi } from './api/dietplan.api';
import {DietPlanData } from '../../interfaces/masters/dietplan';
import { DietPlanService } from './services/dietplan.service';

import {CommonMasterApi } from './api/commonmaster.api';
import {CommonMasterData } from '../../interfaces/masters/commonmaster';
import { CommonMasterService } from './services/commonmaster.service';
import {NotificationApi } from './api/notification.api';
import {NotificationData } from '../../interfaces/masters/notification';
import { NotificationService } from './services/notification.service';
import {BloodBankGenApi } from './api/bloodbankgen.api';
import {BloodBankGenData } from '../../interfaces/masters/bloodbankgen';
import { BloodBankGenService } from './services/bloodbankgen.service';
import {BloodDonorApi } from './api/bloodDonor.api';
import {BloodDonorData } from '../../interfaces/masters/bloodDonor';
import { BloodDonorService } from './services/bloodDonor.service';
import {BloodBankApi } from './api/bloodBank.api';
import {BloodBankData } from '../../interfaces/masters/bloodBank';
import { BloodBankService } from './services/bloodBank.service';
import {CampMstApi } from './api/campMst.api';
import {CampMstData } from '../../interfaces/masters/campMst';
import { CampMstService } from './services/campMst.service';
import {DischargeReasonApi } from './api/discharge-reason.api';
import {DischargeReasonData } from '../../interfaces/masters/discharge-reason';
import { DischargeReasonService } from './services/discharge-reason.service';

import { NurseIntakeOutputService } from './services/nurseintakeoutput.service';
import { NurseIntakeOutputApi } from './api/nurseintakeoutput.api';
import { NurseIntakeOutputData } from '../../interfaces/Ip/nurseintakeoutput';


import { StoreMstApi } from './api/storemst.api';
import { StoreMstData } from '../../interfaces/masters/storemst';
import { StoreMstService } from './services/storemst.service';


import { LabColumnHeaderApi } from './api/labcolumnheader.api';
import { LabColumnHeaderData } from '../../interfaces/masters/labcolumnheader';
import { LabColumnHeaderService } from './services/labcolumnheader.service';

import { LabCultureResultHeaderApi } from './api/labcultureresultheader.api';
import { LabCultureResultHeaderData } from '../../interfaces/masters/labcultureresultheader';
import { LabCultureResultHeaderService } from './services/labcultureresultheader.service';

import { LabTestData } from '../../interfaces/masters/labtest';
import { LabTestService } from './services/labtest.service';
import { LabTestApi } from './api/labtest.api';

import { MachineLabTestConfigData } from '../../interfaces/masters/machinelabtestconfig';
import { MachineLabTestConfigService } from './services/machinelabtestconfig.service';
import { MachineLabTestConfigApi } from './api/machinelabtestconfig.api';

import { JobCategoryData } from '../../interfaces/masters/jobCategory';
import { JobCategoryService } from './services/jobcategory.service';
import { JobCategoryApi } from './api/jobcategory.api';

import { BillService} from './../../../../app/_services/bill.service';
import { BillData } from '../../interfaces/masters/bill';
import { BillApi } from './api/bill.api';

import { IPBillService} from './../../../../app/_services/ipBill.service';
import { IPBillData } from '../../interfaces/masters/ipbill';
import { IPBillApi } from './api/ipBill.api';

import {AdmissionInitialAssessmentService} from './services/admissionInitialAssessment.service';
import { AdmissionInitialAssessmentData } from '../../interfaces/Ip/admissionInitialAssessment';
import { AdmissionInitialAssessmentApi } from './api/admissionInitialAssessment.api';
import {AdmissionAccidentMasterService} from './services/admissionAccidentMasterservice';
import { AdmissionAccidentMasterData } from '../../interfaces/Ip/admissionAccident';
import { AdmissionAccidentMasterApi } from './api/admissionAccidentMaster.api';
import{InvestigationService} from './services/investigations.service';
import { InvestigationData } from '../../interfaces/masters/investigations';
import { InvestigationsApi } from './api/investigations.api';
import{PatientDiagnosisService} from './services/patientdiagnosis.service';
import { PatientDiagnosisData } from '../../interfaces/masters/patientdiagnosis';
import { PatientDiagnosisApi } from './api/patientdiagnosis.api';
import { AllergyService } from './services/allergy.service';
import { AllergyData } from '../../interfaces/masters/allergy';
import { AllergyApi } from './api/allergy.api';

import { PatientAllergyService } from './services/patientallergy.service';
import { PatientAllergyData } from '../../interfaces/masters/patientAllergy';
import { PatientAllergyApi } from './api/patientallergy.api';
import { PatientSocialHabitsService } from './services/patientsocialhabits.service';
import { PatientSocialHabitsData } from '../../interfaces/masters/patientSocialHabits';
import { PatientSocialHabitsApi } from './api/patientsocialhabits.api';
import { CommunicationTemplateData } from '../../interfaces/masters/communicationtemplate';
import { CommunicationTemplateService } from './services/communicationtemplate.service';
import { CommunicationTemplateApi } from './api/communicationtemplate.api';

import { CommunicationGroupData } from '../../interfaces/masters/communicationgroup';
import { CommunicationGroupService } from './services/communicationgroup.service';
import { CommunicationGroupApi } from './api/communicationgroup.api';
import { CommunicationSendMessageData } from '../../interfaces/masters/communicationsendmessage';
import { CommunicationSendMessageService } from './services/communicationsendmessage.service';
import {CommunicationSendMessageApi } from './api/communicationsendmessage.api';
import {AutoCommunicationSettingsData } from '../../interfaces/masters/autocommunicationsettings';
import{AutoCommunicationSettingsService} from './services/autocommunicationsettings.service';
import{AutoCommunicationSettingsApi} from './api/autocommunicationsettings.api';
import {AutoCommDetailsData } from '../../interfaces/masters/autocommdetails';
import{AutoCommDetailsService} from './services/autocommdetails.service';
import{AutoCommDetailsApi} from './api/autocommdetails.api';
import { DoctorsScheduleApi } from './api/doctors-schedule.api';
import { DoctorsScheduleData } from '../../interfaces/patient-services/doctors-schedule';
import { DoctorsScheduleService } from './services/doctors-schedule.service';
import { DoctorsAvailData } from '../../interfaces/patient-services/doctors-avail';
import { DoctorsAvailService } from './services/doctorsAvail.service';
import { DoctorsAvailApi } from './api/doctors-avail.api'

import { PatientinstructionApi } from './api/patientinstruction.api';
import { PatientinstructionData } from '../../interfaces/masters/patientinstruction';
import { PatientinstructionService } from './services/patientinstruction.service';

import { PatientComplaintData } from '../../interfaces/masters/patientcomplaint';
import { PatientComplaintService } from './services/patientcomplaint.service';
import {PatientComplaintApi} from './api/patientcomplaint.api';
import { PatientAppointmentData } from '../../interfaces/patient-services/patient-appointment';
import { PatientAppointmentService } from './services/patient-appointment.service';
import { PatientAppointmentApi } from './api/patient-appointment.api';

import { SeqTemplateData } from '../../interfaces/masters/sequenceTemplate';
import { SeqTemplateService } from './services/seqTemplate.service';
import { SeqTemplateApi } from './api/seqTemplate.api';
import {BookingData } from '../../interfaces/masters/booking';
import {BookingService } from './services/booking.service';
import {BookingApi} from './api/booking.api';

import { PatientPrescriptionData } from '../../interfaces/masters/patientprescription';
import { PatientPrescriptionService } from './services/patientprescription.service';
import {PatientPrescriptionApi} from './api/patientprescription.api';


import { PatientDemographicsMasterApi } from './api/patientDemographicsMaster.api';
import { PatientDemographicsMasterData } from '../../interfaces/masters/patientDemographicsMaster';
import { PatientDemographicsMasterService } from './services/patientDemographicsMaster.service';
import { PatientvitalApi } from './api/patientvital.api';
import { PatientVitalData } from '../../interfaces/masters/patientvital';
import { PatientvitalService } from './services/patientvital.service';

import {DoctorUnavailablityApi} from './api/DoctorUnavailability.api';
import { DoctorUnavailablityData } from '../../interfaces/masters/DoctorUnavailablity';
import {DoctorUnavailablityService } from './services/DoctorUnavailablity.service';
import {HighRiskApi} from './api/highrisk.api';
import {HighRiskData  } from '../../interfaces/masters/highrisk';
import {HighRiskService } from './services/highrisk.service';
import { VisitData } from '../../interfaces/ehr/visit';
import { VisitService } from './services/visit.service';
import { VisitApi } from './api/visit.api';

import {SocialHabitsApi} from './api/socialhabits.api';
import {SocialHabitsData  } from '../../interfaces/masters/socialhabits';
import {SocialHabitsService } from './services/socialhabits.service';

import { PatientMedicalHistoryApi } from './api/patientmedicalhistory.api';
import { PatientMedicalHistoryData } from '../../interfaces/masters/patientMedicalHistory';
import { PatientMedicalHistoryService } from './services/patientmedicalhistory.service';
import { MedicalHistoryApi } from './api/medicalhistory.api';
import { MedicalHistoryData } from '../../interfaces/masters/medicalhistory';
import { MedicalhistoryService } from './services/medicalhistory.service';

import { PatientMensturalService } from './services/patientMenstural.service';
import { PatientMensturalData } from '../../interfaces/masters/patientMenstural';
import { PatientMensturalApi } from './api/patientMenstural.api';
import { ProblemApi } from './api/problem.api';
import { ProblemData } from '../../interfaces/masters/problem';
import { ProblemService } from './services/problem.service';

import { TreatmentPlanApi } from './api/treatmentplan.api';
import { TreatmentPlanData } from '../../interfaces/masters/treatmentplan';
import { TreatmentPlanService } from './services/treatmentplan.service';

import { PatientexamintionApi } from './api/patientexamintion.api';
import { PatientexaminationService } from './services/patientexamination.service';
import { PatientexaminationData } from '../../interfaces/masters/patientexamination';

import { PatientFamilyMedicalHistoryApi } from './api/patientfamilymedicalhistory.api';
import { PatientFamilyMedicalHistoryData } from '../../interfaces/masters/patientFamilyMedicalHistory';
import { PatientFamilyMedicalHistoryService } from './services/patientfamilymedicalhistory.service';

import {AdmissionTypeApi  } from './api/admissiontype.api';
import { AdmissionTypeService} from './services/admissiontype.service';
import { AdmissionTypeData } from '../../interfaces/masters/admissiontype';

import {CountApi  } from './api/count.api';
import { CountService} from './services/count.service';
import { CountData } from '../../interfaces/masters/count';

import { PatientsystemexaminationApi } from './api/patientsystemexamination.api';
import { PatientsystemexaminationData } from '../../interfaces/masters/patientsystemexamination';
import { PatientsysytemexaminationService } from './services/patientsysytemexamination.service';

import { FavoriteMedicineData } from '../../interfaces/masters/favoritemedicine';
import { FavoriteMedicineService } from './services/favoritemedicine.service';
import {FavoriteMedicineApi} from './api/favoritemedicine.api';

import {TrainingClassApi } from './api/trainingclass.api';
import { TrainingClassData } from '../../interfaces/masters/trainingclass';
import { TrainingClassService } from './services/trainingclass.service';

import {AccidentTypeApi } from './api/accidenttype.api';
import { AccidentTypeService } from './services/accidenttype.service';
import {  AccidentTypeData } from '../../interfaces/masters/accidenttype';

import { VaccineApi } from './api/vaccine.api';
import {  VaccineData } from '../../interfaces/masters/vaccine';
import {  VaccineService } from './services/vaccine.service';

import { PatientobstericsApi } from './api/patientobsterics.api';
import { PatientobstericsData } from '../../interfaces/masters/patientobsterics';
import { PatientobstericsService } from './services/patientobsterics.service';
import { patientMiscellaneousApi } from './api/patientMiscellaneous.api';
import { patientMiscellaneousData } from '../../interfaces/masters/patientMiscellaneous';
import { patientmiscellaneousService } from './services/patientmiscellaneous.service';

import{AppointmentStatusData} from '../../interfaces/patient-services/appointment-status-detail';
import {ApptStatusDetailApi} from './api/apptstatusdetail.api';
import{ApptStatusDetail} from './services/apptstatusdetail.service';


import { PackageControllerService } from './services/packageController.service';
import { PackageControllerData} from '../../interfaces/masters/packagecontroller';
import { PackageControllerApi } from './api/packageController.api';

import { TenantPackageService } from './services/tenantPackage.service';
import { TenantPackageData } from '../../interfaces/masters/tenantpackage';
import { TenantPackageApi } from './api/tenantpackage.api';

import { TenantPageService } from './services/tenantPage.service';
import { TenantPageData } from '../../interfaces/masters/tenantpage';
import { TenantPageApi } from './api/tenantpage.api';

import { TenantTaskService } from './services/tenanttask.service';
import { TenantTaskData } from '../../interfaces/masters/tenanttask';
import { TenantTaskApi } from './api/tenanttask.api';
import { PackageModuleService } from './services/packageModule.service';
import { PackageModuleData } from '../../interfaces/masters/packagemodule';
import { PackageModuleApi } from './api/packageModule.api';
import { PatientHighriskApi } from './api/patient-highrisk.api';
import { PatienthighriskData } from '../../interfaces/masters/patient-highrisk';
import { PatientHighriskService } from './services/patient-highrisk.service';


import { PatientbookletApi } from './api/patientbooklet.api';
import { PatientbookletData } from '../../interfaces/masters/patientbooklet';
import { PatientbookletService } from './services/patientbooklet.service';


import { PatientimmunicationApi } from './api/patientimmunication.api';
import { PatientimmunicationData } from '../../interfaces/masters/patientimmunication';
import { PatientimmuicationService } from './services/patientimmuication.service';

import { VaccineBrandDetApi } from './api/vaccinebranddet.api';
import { VaccineBrandDetData } from '../../interfaces/masters/vaccine_branddet';
import { VaccineBrandDetService } from './services/vaccinebranddet.service';
import { RadiologyEhrApi } from './api/radiology-ehr.api';
import { RadiologyEhrData } from '../../interfaces/ehr/radiology-ehr';
import { RadiologyEhrService } from './services/radiology-ehr.service';

import { VaccineSettingApi } from './api/vaccinesetting.api';
import { VaccineSettingData } from '../../interfaces/masters/vaccinesetting';
import { VaccineSettingService } from './services/vaccinesetting.service';

import { VaccineTransactionApi } from './api/vaccinetransaction.api';
import { VaccineTransactionData } from '../../interfaces/masters/vaccinetransaction';
import { VaccineTransactionService } from './services/vaccinetransaction.service';

import { UpiPaymentApi } from './api/UpiPaymentMst.api';
import { UpiPaymentMstData } from '../../interfaces/masters/UpiPaymentMst';
import { UpiPaymentMstService } from './services/UpiPaymentMst.service';

import { PatientCurrentMedicationApi } from './api/patientcurrentmedication.api';
import { PatientCurrentMedicationData } from '../../interfaces/masters/patientcurrentmedication';
import { PatientCurrentMedicationService } from './services/patientcurrentmedication.service';
 
import { FavCaseSheetData } from '../../interfaces/masters/favcasesheet';
import { FavCaseSheetService } from './services/favcasesheet.service';
import {FavCaseSheetApi} from './api/favcasesheet.api';
import{LabResultData} from '../../interfaces/lab/lab-result-detail';
import {LabResultApi} from './api/labresultdetail.api';
import{LabResultService} from './services/labresult.service';

import { patientToothChartApi } from './api/patienttoothchart.api';
import { PatientToothChartService } from './services/patienttoothchart.service';
import { PatientToothChartData } from '../../interfaces/masters/patienttoothchart';

import { LabresultmstApi } from './api/labresultmst.api';
import { LabresultmstService } from './services/labresultmst.service';
import { LabresultmstData } from '../../interfaces/masters/labresultmst';

import { PatientDentalProcedureApi } from './api/patient-dental-procedure.api';
import { PatientDentalProcedureService } from './services/patient-dental-procedure.service';
import { PatientDentalProcedureData } from '../../interfaces/masters/patient-dental-procedure';

import { PatientDentalProblemApi } from './api/patient-dental-problem.api';
import { PatientDentalProblemService } from './services/patient-dental-problem.service';
import { PatientDentalProblemData } from '../../interfaces/masters/patient-dental-problem';


import { PatientDentalTreatmentplanApi } from './api/patient-dental-treatmentplan.api';
import { PatientDentalTreatmentplanService } from './services/patient-dental-treatmentplan.service';
import { PatientDentalTreatmentplanData } from '../../interfaces/masters/patient-dental-treatmentplan';

import { LabGroupData } from '../../interfaces/masters/labgroup';
import { LabGroupService } from './services/labgroup.service';
import {LabGroupApi} from './api/labgroup.api';


import { PhysicianqualificationApi } from './api/physicianqualification.api';
import { PhysicianqualificationData } from '../../interfaces/masters/physicianqualification';
import { PhysicianqualificationService } from './services/physicianqualification.service';


import { PhysicianExperienceApi } from './api/physician-experience.api';
import { PhysicianExperienceData } from '../../interfaces/masters/physician-experience';
import { PhysicianExperienceService } from './services/physician-experience.service';


import { PhysicianAccreditationApi } from './api/physician-accreditation.api';
import { PhysicianAccreditationData } from '../../interfaces/masters/physician-accreditation';
import { PhysicianAccreditationService } from './services/physician-accreditation.service';

import { PhysicianCouncilsApi } from './api/physician-councils.api';
import { PhysicianCouncilsData } from '../../interfaces/masters/physician-councils';
import { PhysicianCouncilsService } from './services/physician-councils.service';

import { LabPackageData } from '../../interfaces/masters/labpackage';
import { LabPackageService } from './services/labpackage.service';
import {LabPackageApi} from './api/labpackage.api';
import { CertificateApi } from './api/certificate.api';
import { CertificateData } from '../../interfaces/patient-services/certificate';
import { CertificateService } from './services/certificate.service';
import { SummaryApi } from './api/summary.api';
import { SummaryData } from '../../interfaces/patient-services/summary';
import { SummaryService } from './services/summary.service';

import{WardData} from '../../interfaces/masters/ward';
import {WardApi} from './api/ward.api';
import{WardService} from './services/ward.service';

import { BuildingData } from '../../interfaces/masters/building';
import { BuildingApi } from './api/building.api';
import { BuildingService } from './services/building.service';

import {FloorData } from '../../interfaces/masters/floor';
import { FloorApi } from './api/floor.api';
import { FloorService } from './services/floor.service';
import {NursingCounterData } from '../../interfaces/masters/nursingcounter';
import { NursingCounterApi } from './api/nursingcounter.api';
import { NursingCounterService } from './services/nursingcounter.service';
import {RoomData } from '../../interfaces/masters/room';
import { RoomApi } from './api/room.api';
import { RoomService } from './services/room.service';
import {BedData } from '../../interfaces/masters/bed';
import { BedApi } from './api/bed.api';
import { BedService } from './services/bed.service';

import { PharmacyService } from './services/pharmacy.service';
import { PharmacyData } from '../../interfaces/masters/pharmacy';
import { PharmacyApi } from './api/pharmacy.api';

import {ReferralSettingsData } from '../../interfaces/masters/referralSettings';
import { ReferralSettingsApi } from './api/referralSettings.api';
import { ReferralSettingsService } from './services/referralSettings.service';
import { BedTransferData } from '../../interfaces/masters/bedtransfer';
import { BedTransferApi } from './api/bedtransfer.api';
import { BedTransferService } from './services/bedtransfer.service';

import { AdmissionMasterData } from '../../interfaces/Ip/admissionMaster';
import { AdmissionMasterApi } from './api/admissionMaster.api';
import { AddmissionMasterService } from './services/admissionMaster.service';
import { DischargeAdviceData } from '../../interfaces/masters/dischargeadvice';
import { DischargeAdviceApi } from './api/dischargeadvice.api';
import { DischargeAdviceService } from './services/dischargeadvice.service';

import { DischargeEntryData } from '../../interfaces/masters/dischargeentry';
import { DischargeEntryApi } from './api/dischargeentry.api';
import { DischargeEntryService } from './services/dischargeentry.service';


import { ModuleMasterService } from './services/module-master.service';
import { ModulemasterData } from '../../interfaces/masters/modulemaster';
import { ModulemasterApi } from './api/modulemaster.api';

import { PagemasterApi } from './api/pagemaster.api';
import { PageMasterService } from './services/page-master.service';
import { PagemasterData } from '../../interfaces/masters/pagemaster';

import { TaskmasterApi } from './api/taskmaster.api';
import { TaskMasterService } from './services/task-master.service';
import { TaskmasterData } from '../../interfaces/masters/taskmaster';

import { AdvanceMasterData } from '../../interfaces/masters/advancemaster';
import {AdvanceMasterApi } from './api/advancemaster.api';
import { AdvanceMasterService } from './services/advancemaster.service';
import { RolesApi } from './api/roles.api';
import { RolesData } from '../../interfaces/common/roles';
import { RolesService } from './services/roles.service';

import { imageatch_detApi } from './api/imageatch_det.api';
import { imageatch_detData } from '../../interfaces/masters/imageatch_det';
import { imageatch_detService } from './services/imageatch_det.service';

import { IpServiceDetData } from '../../interfaces/Ip/ipservicedet';
import { IpServiceDetApi } from './api/ipservicedet.api';
import { IpServiceDetService } from './services/ipservicedet.service';

import { NurseNotesApi } from './api/nurse-notes.api';
import { NurseNotesData } from '../../interfaces/Ip/nurse-notes';
import { NurseNotesService } from './services/nurse-notes.service';

import { MedicineInTakeData } from '../../interfaces/masters/medicineintake';
import { MedicineInTakeApi } from './api/medicineintake.api';
import { MedicineInTakeService } from './services/medicineintake.service';

import { IPInvestigationData } from '../../interfaces/Ip/ipinvestigation';
import {  IPInvestigationApi } from './api/ipinvestigation.api';
import {  IPInvestigationService } from './services/ipinvestigation.service';

import { WardFacilityData } from '../../interfaces/masters/ward-facility';


import { GlossaryData } from '../../interfaces/masters/glossary';
import { GlossaryService } from './services/glossary.service';
import { GlossaryApi } from './api/glossary.api';

import { PrinterSettingsData } from '../../interfaces/masters/printersettings';
import { PrinterSettingsService } from './services/printersettings.service';
import { PrinterSettingsApi } from './api/printersettings.api';

import { PurchaseService } from './services/purchase.services';
import { PurchaseData } from '../../interfaces/masters/purchase';
import { PurchaseApi } from './api/purchase.api';

import { CreditNoteDetService } from './services/creditnotedet.service';
import { CreditNoteDetData } from '../../interfaces/masters/creditnotedet';
import { CreditNoteDetApi } from './api/creditnotedet.api';
import { PurchaseDetailsService } from './services/purchasedetails.service';
import { PurchaseDetailsData } from '../../interfaces/masters/purchasedetails';
import { PurchaseDetailsApi } from './api/purchasedetails.api';

import { CreaditNoteReasonApi } from './api/creaditNoteReason.api';
import { creaditNoteReasonData } from '../../interfaces/masters/creaditNotereason' ;
import { CreaditNoteReasonService } from './services/creadit-note-reason.service';

import { SalesReturnReasonApi } from './api/sales-return-reason.api';
import { SalesReturnReasonData } from '../../interfaces/masters/salesreturnreason';
import { SalesReturnReasonService } from './services/sales-return-reason.service';


import { PurchaseReturnReasonApi } from './api/purchase-return-reason.api';
import { PurchaseReturnReasonData } from '../../interfaces/masters/purchasereturnreason';
import { PurchaseReturnReasonService } from './services/purchase-return-reason.service';

import { PatientCatheterService } from './services/patient-catheter.service';
import { PatientCatheterData } from '../../interfaces/masters/patient-catheter';
import { PatientCatheterApi } from './api/patient-catheter.api';

import { purchaseReturnDetailsService } from './services/purchasereturndetails.service';
import { purchaseReturnDetailsData } from '../../interfaces/masters/purchasereturndetails';
import { purchaseReturnDetailsApi } from './api/purchasereturndetails.api';

import { PurchaseReturnService } from './services/purchasereturn.service';
import { PurchaseReturnData } from '../../interfaces/masters/purchasereturn';
import { PurchaseReturnApi } from './api/purchasereturn.api';

import { VideoAppointmentsData } from '../../interfaces/patient-services/videoAppointment';
import { VideoAppointmentsApi } from './api/videoAppointments.api';
import { VideoAppointmentsService } from './services/videoAppointments.service';

import { SalesMasterService } from './services/salesmaster.service';
import { SalesMasterData } from '../../interfaces/masters/salesmaster';
import { salesMasterDetDtoData } from '../../interfaces/masters/salesmasterdetdto';
import { SalesMasterApi } from './api/salesmaster.api';

import { SalesReturnService } from './services/salesreturn.service';
import { SalesReturnData } from '../../interfaces/masters/sales_return';
import { salesReturnDetailsDtoData } from '../../interfaces/masters/sales_return_details';
import { SalesReturnApi } from './api/salesreturn.api';

import { RehabImpMarketsMstApi } from './api/rehab-imp-markets-mst.api';
import { RehabImpMarketsMstService } from './services/rehab-imp-markets-mst.service';
import { RehabImpMarketsMstData } from '../../interfaces/masters/rehab-imp-markets-mst';

import { StockListApi } from './api/stockList.api';
import { StockListData } from '../../interfaces/pharmacy/StockLists';
import { StockListService } from './services/stockList.service';

import { OpenStockApi } from './api/openstock.api';
import { OpenStockData } from '../../interfaces/pharmacy/openstock';
import { OpenStockService } from './services/openstock.service';
import { PatientRehabImpMarketsApi } from './api/patient-rehab-imp-markets.api';
import { PatientRehabImpMarketsData } from '../../interfaces/masters/patient-rehab-imp-markets';
import { PatientRehabImpMarketsMstService } from './services/patient-rehab-imp-markets-mst.service';

import { PrescriptionListApi } from './api/prescriptionList.api';
import { PrescriptionListData } from '../../interfaces/pharmacy/prescriptionList';
import { PrescriptionListService } from './services/prescriptionList.service';

import { patientoptimizationApi } from './api/patientoptimization.api';
import { patientoptimizationData } from '../../interfaces/masters/patientoptimization';
import { patientoptimizationService } from './services/patientoptimization.service';

import { SalesPaymentApi } from './api/salespayment.api';
import { SalesPaymentData } from '../../interfaces/masters/salespayment';
import { SalesPaymentService } from './services/salespayment.service';


import { SalesMasterHoldApi } from './api/salesmasterhold.api';
import { salesMasterHoldData } from '../../interfaces/masters/salesmasterhold';
import { salesMasterHoldDetailsData } from '../../interfaces/masters/salesmasterholddetails';
import { SalesMasterHoldService } from './services/salesmasterhold.service';

import { LabWorkOrderData } from '../../interfaces/lab/lab-work-order';
import { LabWorkOrderApi } from './api/lab-work-order.api';
import { LabWorkOrderService } from './services/lab-work-order.service'

import { LabTestMethodApi } from './api/labtestmethod.api';
import { LabTestMethodData } from '../../interfaces/masters/labtestmethod';
import { LabTestMethodService } from './services/labtestmethod.service';

import { LabTestMaterialApi } from './api/labtestmaterial.api';
import { LabTestMaterialData } from '../../interfaces/masters/labtestmaterial';
import { LabTestMaterialService } from './services/labtestmaterial.service';

import { PharmacyIndentService } from './services/pharmacyindent.service';
import { PharmacyIndentData } from '../../interfaces/masters/pharmacyindent';
import { PharmacyIndentApi } from './api/pharmacyindent.api';

// Credit Bill interface,api,service imported start by Abirami Paramasivam:-
import { CreditBillReciptService } from './services/CreditBillRecipt.Service';
import { CreditBillReciptMstData } from '../../interfaces/pharmacy/CreditBillReceiptMst';
import { CreditBillReciptApi } from './api/CreditBillRecipt.api';
// Credit Bill interface,api,service imported end by Abirami Paramasivam:-

import { CollectionReportData } from '../../interfaces/report/collectionReport';
import { CollectionReportApi } from './api/collectionReport.api';
import { CollectionReportService } from './services/collectionReport.service';

// Supplier Bill interface,api,service imported start by Abirami Paramasivam:-
import { SupplierBillService } from './services/supplierbill.service';
import { SupplierBillMasterData } from '../../interfaces/pharmacy/SupplierBillMaster';
import { SupplierBillPaymentApi } from './api/SupplierBillPayment.api';
// Supplier Bill interface,api,service imported end by Abirami Paramasivam:-

import { BillServiceWiseReportApi } from './api/bill-service-wise-report.api';
import { BillServiceWiseReportData } from '../../interfaces/report/bill-service-wise-report';
import { BillServiceWiseReportService } from './services/bill-service-wise-report.service';

import { outsidelabmasterService } from './services/outsidelabmaster.service';
import { outsidelabmasterData } from '../../interfaces/masters/outsidelabmaster';
import { outsidelabmasterApi } from './api/outsidelabmaster.api';

//Pharmacy Report

import { StockUpdateHistoryService } from './services/stockupdatehistory.service';
import { StockUpdateHistoryData } from '../../interfaces/masters/stockupdatehistory';
import { StockUpdateHistoryApi } from './api/stockupdatehistory.api';

import { ProductWiseSalesService } from './services/product-wise-sales.service';
import { ProductWiseSalesData } from '../../interfaces/masters/product-wise-sales';
import { ProductWiseSalesApi } from './api/product-wise-sales.api';

import { ScheduleHService } from './services/schedule-h.service';
import { ScheduleHData } from '../../interfaces/masters/schedule-h';
import { ScheduleHApi } from './api/schedule-h.api';


import { PurchaseAbstractService } from './services/purchase-abstract.service';
import { PurchaseAbstractData } from '../../interfaces/masters/purchase-abstract';
import { PurchaseAbstractApi } from './api/purchase-abstract.api';

import { StockTransactionService } from './services/stock-transaction.service';
import { StockTransactionData } from '../../interfaces/masters/stock-transaction';
import { StockTransactionApi } from './api/stock-transaction.api';


import { PrinterSettingsDSData } from '../../interfaces/masters/printersettingsds';
import { PrinterSettingsDsService } from './services/printersettingds.service';
import { PrinterSettingDsApi } from './api/printersettingds.api'; 

import { ceaPatientRegisterData } from '../../interfaces/report/ceaPatientRegister';
import { ceaPatientRegisterService } from './services/caePatientRegister.service';
import { ceaPatientRegisterApi } from './api/ceaPatientRegister.api'; 

import { IndentRequestApi } from './api/IndentRequest.api';
import { IndentRequestHeaderData } from '../../interfaces/pharmacy/IndentRequestHeader';
import { IndentRequestDetailsData } from '../../interfaces/pharmacy/IndentRequestDetails';
import { IndentRequestService } from './services/IndentRequest.service';
import { IndentIssueApi } from './api/IndentIssue.api';
import { IndentIssueHeaderData } from '../../interfaces/pharmacy/IndentIssueHeader';
import { IndentIssueDetailsData } from '../../interfaces/pharmacy/IndentIssueDetails';
import { IndentIssueService } from './services/IndentIssue.service';

import { IndentReceApi } from './api/Indentrec.api';
import { IndentReceiveHeaderData } from '../../interfaces/pharmacy/IndentReceiveHeader';
import { IndentReceiveDetailsData } from '../../interfaces/pharmacy/IndentReceiveDetails';
import { IndentReceiveService } from './services/IndentReceive.servcie';
import { IndentPOApi } from './api/IndentPO.api';
import { IndentPOHeaderData } from '../../interfaces/pharmacy/IndentPOHeader';
import { IndentPODetailsData } from '../../interfaces/pharmacy/IndentPODetails';
import { IndentPOService } from './services/IndentPO.service';

import { OTChecklistApi } from './api/OT-Checklist.api';
import { OTChecklistData } from '../../interfaces/OT/OT-Checklist';
import { OTChecklistService } from './services/OT-Checklist.service';

import { OTcssdApi } from './api/OT-cssd.api';
import { OTCSSDData } from '../../interfaces/OT/OT-CSSD';
import { OTCSSDService } from './services/OT-CSSD.service';

import { otbookingApi } from './api/ot-booking.api';
import { otbookingData } from '../../interfaces/OT/ot-booking';
import { otbookingService } from './services/ot-booking.servics';


import { otscheduleApi } from './api/otschedule.api';
import { scheduleHeaderData } from '../../interfaces/OT/scheduleHeader';
import { otscheduleService } from './services/otschedule.service';

//Asset
import { AssetApi } from './api/asset.api';
import { AssetService } from './services/asset.service';
import { AssetData } from '../../interfaces/masters/asset';

//Invertory Master Pages by Raja 03-02-2021
//Item Mst
import { QualityTeamApi } from '../../../pages/inventory/backend-module/api/master/qualityteam.api';
import { QualityTeamService } from '../../../pages/inventory/backend-module/service/master/qualityteam.service';
import { QualityTeamData } from '../../../pages/inventory/backend-module/interface/master/qualityteam';
//Quality Team
import { ItemApi } from '../../../pages/inventory/backend-module/api/master/item-mst.api';
import { ItemService } from '../../../pages/inventory/backend-module/service/master/item-mst.service';
import { ItemData } from '../../../pages/inventory/backend-module/interface/master/item-mst';

//ItemMrf Mst
import { ItemMfrApi } from '../../../pages/inventory/backend-module/api/master/item-mfr-mst.api';
import { ItemMfrService } from '../../../pages/inventory/backend-module/service/master/item-mfr-mst.service';
import { ItemMfrData } from '../../../pages/inventory/backend-module/interface/master/item-mfr-mst';

//ItemCategory Mst
import { ItemCategoryApi } from '../../../pages/inventory/backend-module/api/master/item-category-mst.api';
import { ItemCategoryService } from '../../../pages/inventory/backend-module/service/master/item-category-mst.service';
import { ItemCategoryData } from '../../../pages/inventory/backend-module/interface/master/item-category-mst';

//ItemStorageShelf Mst
import { ItemStorageShelfApi } from '../../../pages/inventory/backend-module/api/master/item-storage-shelf-mst.api';
import { ItemStorageShelfService } from '../../../pages/inventory/backend-module/service/master/item-storage-shelf-mst.service';
import { ItemStorageShelfData } from '../../../pages/inventory/backend-module/interface/master/item-storage-shelf-mst';

//itemType Mst
import { ItemTypeApi } from '../../../pages/inventory/backend-module/api/master/item-type-mst.api';
import { ItemTypeService } from '../../../pages/inventory/backend-module/service/master/item-type-mst.service';
import { ItemTypeData } from '../../../pages/inventory/backend-module/interface/master/item-type-mst';

import { InventoryPurchaseService } from '../../../pages/inventory/backend-module/service/transaction/purchase.services';
import { InventoryPurchaseData } from '../../../pages/inventory/backend-module/interface/transaction/purchase';
import { InventoryPurchaseApi } from '../../../pages/inventory/backend-module/api/transaction/purchase.api';

import { InventoryPurchaseDetailsService } from '../../../pages/inventory/backend-module/service/transaction/purchasedetails.service';
import { InventoryPurchaseDetailsData } from '../../../pages/inventory/backend-module/interface/transaction/purchasedetails';
import { InventoryPurchaseDetailsApi } from '../../../pages/inventory/backend-module/api/transaction/purchasedetails.api';

import { InventoryPurchaseReturnService } from '../../../pages/inventory/backend-module/service/transaction/purchasereturn.service';
import { InventoryPurchaseReturnData } from '../../../pages/inventory/backend-module/interface/transaction/purchasereturn';
import { InventoryPurchaseReturnApi } from '../../../pages/inventory/backend-module/api/transaction/purchasereturn.api';

import { InventoryPurchaseReturnDetailsService } from '../../../pages/inventory/backend-module/service/transaction/purchasereturndetails.service';
import { InventoryPurchaseReturnDetailsData } from '../../../pages/inventory/backend-module/interface/transaction/purchasereturndetails';
import { InventorypurchaseReturnDetailsApi } from '../../../pages/inventory/backend-module/api/transaction/purchasereturndetails.api';


//LEM,Asset,AssetSubType,Surgery,Table by Santhiya

import { SurgeryData } from '../../interfaces/masters/surgery';
import { SurgeryApi } from './api/surgery.api';
import { SurgeryService } from './services/surgery.service';

import { TableData } from '../../interfaces/masters/table';
import { TableApi } from './api/table.api';
import { TableService } from './services/table.service';


import { lemMstService } from './services/lemMst.service';
import { lemMstData } from '../../interfaces/lab/lemMst';
import { lemMstApi } from './api/lemMst.api';

import{AssetSubTypeData} from '../../interfaces/masters/assetSubType';
import {AssetSubTypeApi } from './api/assetSubType.api';
import{AssetSubTypeService} from './services/assetSubType.service';

import{AssetMstData} from '../../interfaces/masters/assetMst';
import {AssetMstApi } from './api/assetMst.api';
import{AssetMstService} from './services/assetMst.service';

import{BloodData} from '../../interfaces/masters/blood';
import {BloodApi } from './api/blood.api';
import{BloodService} from './services/blood.service';

import{KeyRoleData} from '../../interfaces/masters/keyrole';
import {KeyRoleApi } from './api/keyrole.api';
import{KeyRoleService} from './services/keyrole.service';


import{IvfDonorMstData} from '../../interfaces/masters/ivfdonormst';
import {IvfDonorMstApi } from './api/ivfDonorMst.api';
import{IvfDonorMstService} from './services/ivfDonorMst.service';


import{payerData} from '../../interfaces/patient-services/payer';
import {payerApi } from './api/payer.api';
import{payerService} from './services/payer.service';

import{selfData} from '../../interfaces/patient-services/self';
import {selfApi } from './api/self.api';
import{selfService} from './services/self.service';

import{CombinedVaccineData} from '../../interfaces//masters/combined-vaccine';
import {CombinedVaccineApi } from './api/combined-vaccine.api';
import{CombinedVaccineService} from './services/combined-vaccine.service';

import{PatientVaccineData} from '../../interfaces//masters/patient-vaccine';
import {PatientVaccineApi } from './api/patient-vaccine.api';
import{PatientVaccineService} from './services/patient-vacine.service';

import { VisitModeMstApi } from './api/visitModeMst.api';
import { VisitModeMstData } from '../../interfaces/masters/visitModeMst';
import { VisitModeMstService } from './services/visitModeMst.service';

import { PatientVaccineSettingsApi } from './api/patientvaccinesettings.api';
import { PatientVaccineSettingsData } from '../../interfaces/masters/patientvaccinesettings';
import { PatientVaccineSettingsService } from './services/patientvaccinesettings.service';


import{AdmissionInsuranceData} from '../../interfaces/Ip/admissioInsurancee';
import {AdmissionInsuranceApi } from './api/admissionInsurance.api';
import{AdmissionInsuranceService} from './services/admissionInsurance.service';


import { BankTransApi } from './api/bankTransaction.api';
import { BankTransData } from '../../interfaces/masters/bankTransaction';
import { BankTransService } from './services/bankTransaction.service';


import { IpServiceCategoryReportApi } from './api/ip-service-category-report.api';
import { IpServiceCategoryReportData } from '../../interfaces/report/ip-service-category-report';
import { IpServiceCategoryReportService } from './services/ip-service-category-report.service';

import { TATReportApi } from './api/tatreport.api';
import { TATReportData } from '../../interfaces/lab/tatreport';
import { TATReportService } from './services/tatreport.service';//Inventory Master
import { CourierMstData } from '../../../pages/inventory/backend-module/interface/master/courier-mst';
import { CourierMstService } from '../../../pages/inventory/backend-module/service/master/courier-mst.service';
import { CourierMstApi } from '../../../pages/inventory/backend-module/api/master/courier-mst.api';

import { SmsCreditApi } from './api/smscredit.api';
import { SmsCreditData } from '../../interfaces/masters/smscredit';
import { SmsCreditService } from './services/smscredit.service';

import { directPatientBillingApi } from './api/directpatient.api';
import { directPatientData } from '../../interfaces/patient-services/directpatient';
import { directPatientBillingService } from './services/directpatient.service';

import { WarehouseMstData } from '../../../pages/inventory/backend-module/interface/master/warehouse-mst';
import { WarehouseMstService } from '../../../pages/inventory/backend-module/service/master/warehouse-mst.service';
import { WarehouseMstApi } from '../../../pages/inventory/backend-module/api/master/warehouse-mst.api';

import { QcReasonMstData } from '../../../pages/inventory/backend-module/interface/master/qcreason-mst';
import { QcReasonMstService } from '../../../pages/inventory/backend-module/service/master/qcreason-mst.service';
import { QcReasonMstApi } from '../../../pages/inventory/backend-module/api/master/qcreason-mst.api';

import { SoStatusMstData } from '../../../pages/inventory/backend-module/interface/master/sostatus-mst';
import { SoStatusMstService } from '../../../pages/inventory/backend-module/service/master/sostatus-mst.service';
import { SoStatusMstApi } from '../../../pages/inventory/backend-module/api/master/sostatus-mst.api';

import { PoStatusMstData } from '../../../pages/inventory/backend-module/interface/master/postatus-mst';
import { PoStatusMstService } from '../../../pages/inventory/backend-module/service/master/postatus-mst.service';
import { PoStatusMstApi } from '../../../pages/inventory/backend-module/api/master/postatus-mst.api';


import { ProductModelMstData } from '../../../pages/inventory/backend-module/interface/master/productmodel-mst';
import {ProductModelMstService } from '../../../pages/inventory/backend-module/service/master/productmodel-mst.service';
import {ProductModelMstApi } from '../../../pages/inventory/backend-module/api/master/productmodel-mst.api';


import { ProductCategoryMstData } from '../../../pages/inventory/backend-module/interface/master/productcategory-mst';
import {ProductCategoryMstService } from '../../../pages/inventory/backend-module/service/master/produtcategory-mst.service';
import {ProductCategoryMstApi } from '../../../pages/inventory/backend-module/api/master/productcategory-mst.api';

import { ProductSubCategoryMstData } from '../../../pages/inventory/backend-module/interface/master/procductsubcategory-mst';
import { ProductSubCategoryMstService } from '../../../pages/inventory/backend-module/service/master/productsubcategory-mst.service';
import { ProductSubCategoryMstApi } from '../../../pages/inventory/backend-module/api/master/productsubcategory-mst.api';


import { CultureMstData } from '../../../pages/inventory/backend-module/interface/master/culture-mst';
import {CultureMstService } from '../../../pages/inventory/backend-module/service/master/culture-mst.service';
import {CultureMstApi } from '../../../pages/inventory/backend-module/api/master/culture-mst.api';


import { ScrapReasonMstData } from '../../../pages/inventory/backend-module/interface/master/scrap-reason-mst';
import {ScrapReasonMstService } from '../../../pages/inventory/backend-module/service/master/scrap-reason-mst.service';
import {ScrapReasonMstApi } from '../../../pages/inventory/backend-module/api/master/scrap-reason-mst.api';



import { IpReportData } from '../../interfaces/report/ip-report';
import { IpReportApi } from './api/ip-report.api';
import { IpReportService } from './services/ip-report.service';
import { ItemQualityCheckListData } from '../../../pages/inventory/backend-module/interface/master/itemQualityCheckList';
import { ItemQualityCheckListApi } from '../../../pages/inventory/backend-module/api/master/itemQualityCheckList.api';
import { ItemQualityCheckListService } from '../../../pages/inventory/backend-module/service/master/itemQualityCheckList.service';
import { DischargeTmplApi } from './api/discharge-tmpl.api';
import { DischargeTmplData } from '../../interfaces/masters/discharge-tmpl';
import { DischargeTmplService } from './services/discharge-tmpl.service';
import { EzoTmplApi } from './api/ezo-tmpl.api';
import { EzoTmplData } from '../../interfaces/masters/ezo-tmpl';
import { EzoTmplService } from './services/ezo-tmpl.service';

import { AccountsgroupTypeData } from '../../interfaces/masters/accountsgroup';
import { AccountsgroupApi } from './api/accountsgroup.api';
import { AccountsgroupService } from './services/accountsgroup.service';

import { OPDSequenceMStApi } from './api/opdsequence-mst.api';
import { OPDSequenceMStData } from '../../interfaces/masters/opdsequence-mst';
import { OPDSequenceMStService } from './services/opdsequence-mst.service';
// import { DischargeTmplApi } from '../../../pages/wards/backend-module/api/discharge-tmpl.api';
// import { DischargeTmplData } from '../../../pages/wards/backend-module/interface/discharge-tmpl';
// import { DischargeTmplService } from '../../../pages/wards/backend-module/service/discharge-tmpl.service';

import { CampApi } from './api/camp.api';
import { CampData } from '../../interfaces/masters/camp';
import { CampService } from './services/camp.service';

import { CampPatientnotesApi } from './api/camp-patientnotes.api';
import { CampPatientnotesData } from '../../interfaces/masters/camp-patientnotes';
import { CampPatientnotesService } from './services/camp-patientnotes.service';

import { CommonInventoryData } from '../../../pages/inventory/backend-module/interface/transaction/item-scrap-entry';
import { InventoryCommonApi } from '../../../pages/inventory/backend-module/api/transaction/inventory-common-api.api';
import { InventoryCommonService } from '../../../pages/inventory/backend-module/service/transaction/inventory-common.service.';

import { BloodBankModuleData } from '../../../pages/blood-bank/backend/interface/blood-bank';
import { BloodBankModuleApi } from '../../../pages/blood-bank/backend/api/blood-bank.api';
import { BloodBankModuleService } from '../../../pages/blood-bank/backend/service/blood-bank.services';


//Rajamani
import { BloodIndentIssueDetailsData } from './../../../pages/blood-bank/backend/interface/BloodIndentIssueDetails';
import { BloodIndentIssueHeaaderData } from './../../../pages/blood-bank/backend/interface/BloodIndentIssueHeaader';
import { BloodIndentReceiveHeaderData } from './../../../pages/blood-bank/backend/interface/BloodIndentReceiveHeader';
import { BloodIndentReceiveDetailsData } from './../../../pages/blood-bank/backend/interface/BloodIndentReceiveDetails';
import { BloodIndentReturnHeaderData } from './../../../pages/blood-bank/backend/interface/BloodIndentReturnHeader';
import { BloodIndentReturnDetailsData } from './../../../pages/blood-bank/backend/interface/BloodIndentReturnDetails';

//Ajai
import { GeneralPackageTypeData } from '../../interfaces/masters/generalpackagetype';
import { Generalpackagetypeapi } from './api/generalpackagetype.api';
import { GeneralpackagetypeService } from './services/generalpackagetype.service';

// Rajamani
import { GeneralPackageModuleApi } from './../../../pages/general-package/Backend/api/general-package.api';
import { GeneralPackageModuleData } from '../../../pages/general-package/Backend/interface/general-package';
import { GeneralPackageModuleService } from './../../../pages/general-package/Backend/service/general-package.service';

//Rajamani
import { CrmModuleApi } from '../../../pages/crm/Backend/api/crm.api';
import { CrmModuleService } from '../../../pages/crm/Backend/service/crm.service';
import { CrmModuleData } from '../../../pages/crm/Backend/interface/crm';
import { StockTransferData } from '../../interfaces/pharmacy/stockTransfer';
import { StockTransferService } from './services/stockTransfer.service';
import { StockTransferApi } from './api/stockTransfer.api';

//Mageshwaran
import { ClinicalAssessmentApi } from './api/clinicalassessment.api';
import { ClinicalAssessmentData } from '../../interfaces/masters/clinicalassessment';
import { ClinicalAssessmentService } from './services/clinicalassessment.service';
import { PatientScoreConfigMstApi } from './api/patientscoreconfigmst.api';
import { PatientScoreConfigMstService } from './services/patientscoreconfigmst.service';
import { PatientScoreConfigData } from '../../interfaces/masters/scoreconfigmst';
import { NurseHandOverData } from '../../interfaces/masters/nursehandover';
import { NurseHandOverApi } from './api/nurse-handover.api';
import { NursehandoverService } from './services/nursehandover.service';

import { VentilatorPriceSettingsData } from '../../../pages/inventory/backend-module/interface/master/Ventilator-Price-Settings';
import { VentilatorPriceSettingsService } from '../../../pages/inventory/backend-module/service/master/Ventilator-price-settings.service';
import { VentilatorPriceSettingsAPI } from '../../../pages/inventory/backend-module/api/master/ventilator-price-settings.api';

//Ajai
import { mailSeriveApi } from './api/mailService.api';

//Anandaraj
import {ApprovalModuleApi} from '../../../pages/approval/backend/api/approval.api';
import {ApprovalModuleData} from '../../../pages/approval/backend/interface/approval.interface';
import {ApprovalModuleService} from '../../../pages/approval/backend/services/approval.service';

//For Vopd - Added By Mageshwaran on 25-10-2024
import { VopdData } from '../../interfaces/vopd/vopd';
import { VopdApi } from './api/vopd.api';
import { VopdService } from './services/vopd.service';


import { HmsLocationService } from './services/hms-location.service';
import { HmsLocationData } from '../../interfaces/masters/hms-location';
import { HmsLocationApi } from './api/hms-location.api';
import { WhatsAppIntegrationService } from './services/whatsappIntegration.service';
import { WhatsappIntegration } from '../../interfaces/common/whatsappIntegration';


import { SellerService } from './services/seller.service';
import { SellerData } from '../../interfaces/masters/seller';
import { sellerApi } from './api/seller.api';
import { MailIntegrationService } from './services/MailIntegration.service';
import { MailIntegration } from '../../interfaces/common/mailIntegration';

import { PackageMasterApi } from './api/packagemaster.api';
import { PackageMasterData } from '../../interfaces/masters/packagemaster';
import { PackageMasterService } from './services/packagemaster.service';
import { DivisionMstApi } from './api/division-mst.api';
import { DivisionMstData } from '../../interfaces/masters/division-mst';
import { DivisionMstService } from './services/division-mst.service';
import { DivisionDistrictMapApi } from './api/division-district-map.api';
import { DivisionDistrictMapData } from '../../interfaces/masters/division-district-map';
import { DivisionDistrictMapService } from './services/division-district-map.service';
import { HubMstApi } from './api/hub-mst.api';
import { HubMstData } from '../../interfaces/masters/hub-mst';
import { HubMstService } from './services/hub-mst.service';
import { SpokeMstApi } from './api/spoke-mst.api';
import { SpokeMstData } from '../../interfaces/masters/spoke-mst';
import { SpokeMstService } from './services/spoke-mst.service';
import { UserEntityMappingApi } from './api/user-entity-mapping.api';
import { UserEntityMappingData } from '../../interfaces/masters/user-entity-mapping';
import { UserEntityMappingService } from './services/user-entity-mapping.service';


const API = [BloodBankModuleApi,InventoryCommonApi,CampPatientnotesApi,CampApi,SmsCreditApi,directPatientBillingApi,AdmissionInsuranceApi,PatientVaccineApi,CombinedVaccineApi,selfApi,payerApi,otscheduleApi,otbookingApi,OTcssdApi,OTChecklistApi,IndentPOApi,TenantMasterPackageApi,IndentRequestApi,IndentIssueApi,PrescriptionListApi,StockListApi, VideoAppointmentsApi,UsersApi, IPBillApi,CountriesApi, SettingsApi, TenantApi, TenantBranchApi, BankApi, DepartmentApi, DesignationApi, UsertypeApi, HttpService,
  CountryApi, StateApi, DistrictApi, InsuranceApi, PayersApi, QualificationsApi, InstitutionsApi, AccreditationApi, ExpenseApi, ReferralApi, PhysicianApi,ItemQualityCheckListApi,
  CouncilApi, EmployeeApi, DiagnosisApi, ChiefComplaintsApi, LanguagesApi, InstructionApi, PatientRegistrationApi, PatientPayerApi, ServiceCategoryApi, UnitMstApi, FamilyLinkApi,
  GenericApi, MedicineManufacturersApi, MedicineApi, MedicineCategoryApi, ServiceApi, LabCategoryApi, ExaminationApi, ProcedureApi, SupplierApi, SalesManApi, LabCultureHeaderApi, StorageShelfApi, StoreMstApi, LabColumnHeaderApi,
  LabCultureResultHeaderApi,ReferralSettingsApi, LabTestApi, BillApi, PatientAppointmentApi, CommunicationTemplateApi, CommunicationGroupApi, DoctorsScheduleApi, DoctorsAvailApi, PatientDiagnosisApi, InvestigationsApi, PatientinstructionApi, PatientComplaintApi, CommunicationSendMessageApi, SeqTemplateApi, BookingApi,
  AutoCommunicationSettingsApi, AutoCommDetailsApi, PatientPrescriptionApi, PatientvitalApi,PatientDemographicsMasterApi, DoctorUnavailablityApi, HighRiskApi, VisitApi, SocialHabitsApi, MedicalHistoryApi, AllergyApi, PatientAllergyApi, ProblemApi, PatientexamintionApi, PatientsystemexaminationApi, PatientSocialHabitsApi, PatientMedicalHistoryApi, PatientFamilyMedicalHistoryApi,
  TreatmentPlanApi, AdmissionTypeApi, ModulemasterApi,FavoriteMedicineApi, TrainingClassApi, AccidentTypeApi, PatientMensturalApi, VaccineApi, PatientobstericsApi, PatientHighriskApi, patientMiscellaneousApi, PatientbookletApi, PatientimmunicationApi, VaccineBrandDetApi, ApptStatusDetailApi, RadiologyEhrApi, VaccineSettingApi, VaccineTransactionApi, PatientCurrentMedicationApi, DietPlanApi, FavCaseSheetApi, DischargeReasonApi, UpiPaymentApi, LabResultApi, LabresultmstApi, PatientDentalProcedureApi, PatientDentalProblemApi, LabGroupApi,PaymentApi,MandatoryTemplateApi,CreditNoteDetApi,SupplierPaymentApi,
  IpServiceDetApi, JobCategoryApi,AdmissionAccidentMasterApi,NurseIntakeOutputApi,NurseNotesApi,ShiftMstApi,MedicineInTakeApi,IPInvestigationApi,SummaryApi,GlossaryApi,PrinterSettingsApi,CustomerApi, PharmacyApi,HospitalSettingsApi, PurchaseApi, CreaditNoteReasonApi,SalesReturnReasonApi, PurchaseReturnReasonApi,QualityTeamApi,
  PatientDentalTreatmentplanApi, AdmissionInitialAssessmentApi,TenantModuleApi,TenantTaskApi,TenantPackageApi,PhysicianqualificationApi, TenantPageApi,PackageModuleApi,PhysicianExperienceApi,PackageControllerApi, patientToothChartApi, PhysicianAccreditationApi, PhysicianCouncilsApi, LabPackageApi, WardApi, BuildingApi,FloorApi,NursingCounterApi,CertificateApi,RoomApi,BedApi, DischargeAdviceApi,DischargeEntryApi,AdmissionMasterApi,BedTransferApi,ModulemasterApi,PagemasterApi,TaskmasterApi,AdvanceMasterApi, RolesApi,LaundryItemApi,LaundryIssuedApi,LaundryRecDetailApi,imageatch_detApi,AssetTypeApi,HsnSacApi,
  IpServiceDetApi,VentilatorPriceSettingsAPI,  OpenStockApi,JobCategoryApi,AdmissionAccidentMasterApi,NurseIntakeOutputApi,NurseNotesApi,ShiftMstApi,MedicineInTakeApi,IPInvestigationApi,SummaryApi,GlossaryApi,PrinterSettingsApi,CustomerApi, PharmacyApi,HospitalSettingsApi, PurchaseApi, CreaditNoteReasonApi,SalesReturnReasonApi, PurchaseReturnReasonApi,PatientCatheterApi,PurchaseReturnApi,PurchaseDetailsApi,purchaseReturnDetailsApi,SalesMasterApi,SalesReturnApi,RehabImpMarketsMstApi,PatientRehabImpMarketsApi,patientoptimizationApi,SalesMasterHoldApi,SalesPaymentApi,LabWorkOrderApi,LabTestMethodApi,LabTestMaterialApi, PharmacyIndentApi,
  CreditBillReciptApi,CollectionReportApi,SupplierBillPaymentApi,BillServiceWiseReportApi,outsidelabmasterApi,ProductWiseSalesApi, ScheduleHApi, PurchaseAbstractApi, StockTransactionApi,StockUpdateHistoryApi,PrinterSettingDsApi,IndentReceApi,AssetApi,ImplantApi,CountApi,ceaPatientRegisterApi, ReferralSettlementApi,
  ItemApi,ItemMfrApi,ItemCategoryApi,ItemStorageShelfApi,ItemTypeApi, WardBasedDefaultServiceApi,AccountsgroupApi,CommonMasterApi,
 InventoryPurchaseApi, InventoryPurchaseDetailsApi, InventoryPurchaseReturnApi, InventorypurchaseReturnDetailsApi,SurgeryApi, TableApi, lemMstApi,AssetSubTypeApi, AssetMstApi, BloodApi, KeyRoleApi, PatientWalletApi,IvfDonorMstApi,VisitModeMstApi,PatientVaccineSettingsApi, BankTransApi, IpServiceCategoryReportApi,TATReportApi,MachineLabTestConfigApi,CourierMstApi , DischargeTmplApi,EzoTmplApi,WarehouseMstApi, QcReasonMstApi , PoStatusMstApi , SoStatusMstApi,ProductModelMstApi, ProductCategoryMstApi, ProductSubCategoryMstApi, CultureMstApi, CollectionReportApi,ScrapReasonMstApi,IpReportApi,
BloodBankGenApi,BloodBankApi,BloodDonorApi,CampMstApi, OPDSequenceMStApi, NotificationApi, Generalpackagetypeapi,GeneralPackageModuleApi,CrmModuleApi,StockTransferApi,ClinicalAssessmentApi,PatientScoreConfigMstApi,NurseHandOverApi,mailSeriveApi,
ApprovalModuleApi,VopdApi,HmsLocationApi,sellerApi,PackageMasterApi,DivisionMstApi,DivisionDistrictMapApi,HubMstApi,SpokeMstApi,UserEntityMappingApi];






const SERVICES = [
  {provide : GeneralPackageModuleData , useClass:GeneralPackageModuleService},
  {provide : StockTransferData , useClass:StockTransferService},
  {provide : CrmModuleData , useClass:CrmModuleService},
  {provide : BloodBankModuleData , useClass:BloodBankModuleService},
  { provide:CommonInventoryData,useClass:InventoryCommonService},
  { provide: OPDSequenceMStData, useClass:OPDSequenceMStService},
  { provide: CampPatientnotesData, useClass: CampPatientnotesService},
  { provide: CampData, useClass: CampService},
  { provide: EzoTmplData, useClass: EzoTmplService },
  { provide: DischargeTmplData, useClass: DischargeTmplService },
{ provide: directPatientData, useClass: directPatientBillingService },
{ provide: ItemQualityCheckListData, useClass: ItemQualityCheckListService },
  { provide: SmsCreditData, useClass: SmsCreditService },
  { provide: AdmissionInsuranceData, useClass: AdmissionInsuranceService },
  { provide: PatientVaccineData, useClass: PatientVaccineService },
  { provide: CombinedVaccineData, useClass: CombinedVaccineService },
  { provide: selfData, useClass: selfService },
  { provide: payerData, useClass: payerService },
  { provide: WardBasedDefaultServiceData, useClass: WardBasedDefaultServcService },
  { provide: scheduleHeaderData, useClass: otscheduleService },
  { provide: otbookingData, useClass: otbookingService },
  { provide: PatientWalletData, useClass: PatientWalletService },
  { provide: OTCSSDData, useClass: OTCSSDService },
  { provide: OTChecklistData, useClass: OTChecklistService },
  { provide: IndentPOHeaderData, useClass: IndentPOService },
  { provide: IndentReceiveHeaderData, useClass: IndentReceiveService },
  { provide: IndentRequestHeaderData, useClass: IndentRequestService },
  { provide: IndentIssueHeaderData, useClass: IndentIssueService },
 { provide: PrinterSettingsDSData, useClass: PrinterSettingsDsService },
 { provide: ceaPatientRegisterData, useClass: ceaPatientRegisterService },
{ provide: outsidelabmasterData, useClass: outsidelabmasterService },
{ provide: LabWorkOrderData, useClass: LabWorkOrderService },
{ provide: PrescriptionListData, useClass: PrescriptionListService },
{ provide: MandatoryTemplateData, useClass: MandatoryTemplateService },
{ provide: CreditNoteDetData, useClass: CreditNoteDetService },
{ provide: SupplierPaymentData, useClass: SupplierPaymentService },
{ provide: TenantMasterPackageData, useClass: TenantMasterPackageService },
  { provide: creaditNoteReasonData, useClass: CreaditNoteReasonService },
  { provide: SalesReturnReasonData, useClass: SalesReturnReasonService },
  { provide: PurchaseReturnReasonData, useClass: PurchaseReturnReasonService },
  { provide: ReferralSettlementData, useClass: ReferralSettlementService },
  { provide: QualityTeamData, useClass: QualityTeamService },

  { provide: UserData, useClass: UsersService },
  { provide: CustomerTypeData, useClass: CustomerTypeService },
  { provide: RadiologyEhrData, useClass: RadiologyEhrService },
  { provide: DiagnosisData, useClass: DiagnosisService },
  { provide: CouncilData, useClass: CouncilService },
  { provide: StateData, useClass: StateMstService },
  { provide: DistrictData, useClass: DistrictMstService },
  { provide: countriesMst, useClass: CountryMstService },
  { provide: SettingsData, useClass: SettingsService },
  { provide: DepartmentData, useClass: DepartmentService },
  { provide: DesignationtData, useClass: DesignationService },

  { provide: ImplantData, useClass: ImplantService },

  { provide: UsertypeData, useClass: UsertypeService },
   { provide: InsuranceData, useClass: InsuranceService },
  { provide: PayersData, useClass: PayersService },
  { provide: AccreditationData, useClass: AccreditationService },
   { provide: QualificationsData, useClass: QualificationsService },
   { provide: InstitutionsData, useClass: InstitutionsService },
  { provide: ExpenseData, useClass: ExpenseService },
  { provide: ReferralData, useClass: ReferralService },
  {provide: TenantData, useClass:TenantService} ,
  { provide: PhysicianData, useClass: PhysicianMstService },
   { provide: DischargeReasonData, useClass: DischargeReasonService },
    { provide: BankData, useClass: BankService },
	{ provide: InstructionData, useClass: InstructionService },
  { provide: LanguagesData, useClass: LanguagesService },
  {provide: TenantBranchData, useClass:TenantBranchService},
  { provide: EmployeeData, useClass: EmployeeService },
  {provide: ChiefComplaintsData, useClass:ChiefComplaintsService},
  { provide: PatientRegistrationData, useClass: PatientRegistrationMstService },
  { provide: PatientPayerData, useClass: PatientPayerMstService },
  {provide: ServiceCategoryData, useClass:ServiceCategoryService},
  {provide: FamilLinkData, useClass:FamilyLinkService},
  {provide:UnitMstData, useClass:UnitMstService},
   {provide:GenericData, useClass:GenericService},
  {provide:MedicineManufacturersData, useClass:MedicineManufacturersService},
  {provide:MedicineData, useClass:MedicineService},
  {provide: MedicineCategoryData, useClass:MedicineCategoryService},
  { provide: ServiceData, useClass: ServiceService },
  {provide: LabCategoryData, useClass:LabCategoryService},
  {provide: AssetTypeData, useClass:AssetTypeService},
  { provide: ExaminationData, useClass: ExaminationService },
  { provide: ProcedureData, useClass: ProcedureService },
    { provide: SupplierData, useClass: SupplierService },
    { provide: HsnSacData, useClass: HsnSacService },
        { provide: SalesManData, useClass: SalesManService },
	 { provide: LabCultureHeaderData, useClass: LabCultureHeaderService },
	   { provide: StorageShelfData, useClass: StorageshelfService },
    { provide: StoreMstData, useClass: StoreMstService },
    { provide: LabColumnHeaderData, useClass: LabColumnHeaderService }	,
    { provide: LabCultureResultHeaderData, useClass: LabCultureResultHeaderService }	,
	{ provide: LabTestData, useClass: LabTestService },
  { provide: BillData, useClass: BillService },
{ provide: IPBillData, useClass: IPBillService },
   { provide: InvestigationData, useClass: InvestigationService },
  { provide: PatientinstructionData, useClass: PatientinstructionService },
	{ provide: PatientDiagnosisData, useClass: PatientDiagnosisService },
	 { provide: CommunicationTemplateData, useClass: CommunicationTemplateService },
  { provide: CommunicationGroupData, useClass: CommunicationGroupService },
  {provide:CommunicationSendMessageData,useClass:CommunicationSendMessageService},
{provide:AutoCommunicationSettingsData,useClass:AutoCommunicationSettingsService},
{provide:AutoCommDetailsData,useClass:AutoCommDetailsService},
  { provide: DoctorsScheduleData, useClass: DoctorsScheduleService },
  { provide: DoctorsAvailData, useClass: DoctorsAvailService },
  { provide: PatientComplaintData, useClass: PatientComplaintService },
  { provide: PatientAppointmentData, useClass: PatientAppointmentService },
  { provide: SeqTemplateData, useClass: SeqTemplateService },
  { provide: BookingData, useClass: BookingService },
  { provide: PatientPrescriptionData, useClass: PatientPrescriptionService },
   { provide: AllergyData, useClass: AllergyService },
     { provide: PatientAllergyData, useClass: PatientAllergyService },
  { provide: PatientVitalData, useClass: PatientvitalService },
 { provide: PatientDemographicsMasterData, useClass: PatientDemographicsMasterService },
 { provide: PatientSocialHabitsData, useClass: PatientSocialHabitsService},
   { provide: ShiftMstData, useClass: ShiftMstService},
   { provide: DoctorUnavailablityData,useClass: DoctorUnavailablityService },
  { provide: HighRiskData,useClass: HighRiskService },
  { provide: VisitData, useClass: VisitService },
  { provide: SocialHabitsData,useClass: SocialHabitsService }, 
   { provide: NotificationData,useClass: NotificationService },
   { provide: DietPlanData,useClass: DietPlanService },
   { provide: CommonMasterData,useClass: CommonMasterService },
      { provide: LaundryItemData, useClass: LaundryItemService },
   { provide: LaundryIssuedData, useClass: LaundryIssuedService },
   { provide: LaundryRecDetailData, useClass: LaundryRecDetailService },
{ provide: AdmissionInitialAssessmentData , useClass: AdmissionInitialAssessmentService  },
{ provide: AdmissionAccidentMasterData , useClass: AdmissionAccidentMasterService  },
{ provide: BloodBankGenData,useClass: BloodBankGenService },
{ provide: BloodBankData,useClass: BloodBankService },
{ provide: BloodDonorData,useClass: BloodDonorService },
  { provide: BloodIndentIssueDetailsData, useClass: BloodDonorService },
  { provide: BloodIndentIssueHeaaderData, useClass: BloodDonorService },
  { provide: BloodIndentReceiveDetailsData, useClass: BloodDonorService },
  { provide: BloodIndentReceiveHeaderData, useClass: BloodDonorService },
 { provide: CampMstData,useClass: CampMstService }, 
   { provide: MedicalHistoryData, useClass: MedicalhistoryService },
   { provide: ProblemData, useClass: ProblemService },
   { provide: TreatmentPlanData, useClass:TreatmentPlanService },
  
    { provide: PatientMedicalHistoryData, useClass: PatientMedicalHistoryService },
   { provide: PatientexaminationData, useClass: PatientexaminationService },
    { provide: PatientFamilyMedicalHistoryData, useClass: PatientFamilyMedicalHistoryService },
    { provide: AdmissionTypeData, useClass: AdmissionTypeService },
    { provide: CountData, useClass: CountService },
   { provide: PatientsystemexaminationData, useClass: PatientsysytemexaminationService },
   { provide: FavoriteMedicineData, useClass: FavoriteMedicineService },
   { provide: AccidentTypeData, useClass: AccidentTypeService },
    { provide: TrainingClassData, useClass: TrainingClassService },
    { provide: PatientMensturalData, useClass: PatientMensturalService },
    { provide: VaccineData, useClass: VaccineService },
    { provide: PatientobstericsData, useClass: PatientobstericsService },
     { provide: PatienthighriskData, useClass: PatientHighriskService },
     { provide: PatientbookletData, useClass: PatientbookletService },
     { provide: PatientimmunicationData, useClass: PatientimmuicationService } ,
     { provide: patientMiscellaneousData, useClass: patientmiscellaneousService },
      { provide: VaccineBrandDetData, useClass: VaccineBrandDetService },
       { provide: AppointmentStatusData, useClass: ApptStatusDetail },
        { provide: VaccineSettingData, useClass: VaccineSettingService },
	{ provide: VaccineTransactionData, useClass: VaccineTransactionService },
	  { provide: PatientCurrentMedicationData, useClass: PatientCurrentMedicationService },
	   { provide: FavCaseSheetData, useClass: FavCaseSheetService },
	    { provide: UpiPaymentMstData, useClass: UpiPaymentMstService },
 { provide: LabResultData, useClass: LabResultService },
       { provide: LabresultmstData, useClass: LabresultmstService },
     { provide: PatientDentalProcedureData, useClass: PatientDentalProcedureService },

      { provide: PatientDentalProblemData, useClass: PatientDentalProblemService },
     { provide: PatientDentalTreatmentplanData, useClass: PatientDentalTreatmentplanService },
      { provide: PhysicianqualificationData, useClass: PhysicianqualificationService },
      { provide: PhysicianExperienceData, useClass: PhysicianExperienceService },
      { provide: PhysicianAccreditationData, useClass: PhysicianAccreditationService },
      { provide: LabGroupData, useClass: LabGroupService },
      
      { provide: PhysicianCouncilsData, useClass: PhysicianCouncilsService },
        { provide: LabPackageData, useClass: LabPackageService },
{ provide: PatientToothChartData, useClass: PatientToothChartService },
{provide: WardData, useClass:WardService},
 { provide: BuildingData, useClass: BuildingService },
  { provide: FloorData, useClass: FloorService },
  { provide: NursingCounterData, useClass:NursingCounterService },
  { provide: RoomData, useClass:RoomService },
  { provide: BedData, useClass:BedService },
 { provide: AdmissionMasterData, useClass: AddmissionMasterService },
  { provide: CertificateData, useClass: CertificateService },
  { provide: SummaryData, useClass: SummaryService },
   { provide: DischargeEntryData, useClass:DischargeEntryService },
  { provide: DischargeAdviceData, useClass: DischargeAdviceService },
  { provide: BedTransferData, useClass: BedTransferService },
{ provide: ReferralSettingsData, useClass: ReferralSettingsService },
  { provide: ModulemasterData, useClass: ModuleMasterService },
  { provide: PagemasterData, useClass: PageMasterService },
  { provide: TaskmasterData, useClass: TaskMasterService },
    { provide: PackageControllerData, useClass: PackageControllerService },
{ provide: PackageModuleData, useClass: PackageModuleService },
{ provide: AdvanceMasterData, useClass: AdvanceMasterService },
{ provide: TenantPackageData, useClass: TenantPackageService },
{ provide: TenantModuleData, useClass: TenantModuleService },
{ provide: RolesData, useClass: RolesService },
  { provide: TenantPageData, useClass: TenantPageService },
  { provide: TenantTaskData, useClass: TenantTaskService },
  { provide: PaymentData, useClass: PaymentService },
 { provide: imageatch_detData, useClass: imageatch_detService },
{ provide: IpServiceDetData, useClass: IpServiceDetService },
{ provide: JobCategoryData, useClass: JobCategoryService },
 { provide: NurseIntakeOutputData, useClass: NurseIntakeOutputService }, 
 
{ provide: NurseNotesData, useClass: NurseNotesService },
{ provide: MedicineInTakeData, useClass:MedicineInTakeService },
{ provide: IPInvestigationData, useClass: IPInvestigationService },
{ provide: WardFacilityData, useClass: WardService },

{ provide: GlossaryData, useClass: GlossaryService },
{ provide: PrinterSettingsData, useClass: PrinterSettingsService },


  { provide: HospitalSettingsData, useClass: HospitalSettingsService },
    { provide: PharmacyData, useClass: PharmacyService },
    { provide: HmsLocationData, useClass: HmsLocationService },
     { provide: CustomerData, useClass: CustomerService },
       { provide: PurchaseData, useClass: PurchaseService },
       { provide: PurchaseDetailsData, useClass: PurchaseDetailsService },
  { provide: PurchaseReturnData, useClass: PurchaseReturnService },
  { provide: purchaseReturnDetailsData, useClass: purchaseReturnDetailsService },
       { provide: PatientCatheterData, useClass: PatientCatheterService },
       { provide: RehabImpMarketsMstData, useClass: RehabImpMarketsMstService },

       { provide: PatientRehabImpMarketsData, useClass: PatientRehabImpMarketsMstService },
       
       
       { provide: SalesMasterData, useClass: SalesMasterService },
       { provide: salesMasterDetDtoData, useClass: SalesMasterService },
       { provide: SalesReturnData, useClass: SalesReturnService },
       { provide: salesReturnDetailsDtoData, useClass: SalesReturnService },
       { provide: VideoAppointmentsData, useClass: VideoAppointmentsService },
        { provide: StockListData, useClass: StockListService },
         { provide: OpenStockData, useClass: OpenStockService },
	{ provide: patientoptimizationData, useClass: patientoptimizationService },
	 { provide: salesMasterHoldDetailsData, useClass: SalesMasterHoldService },
       { provide: salesMasterHoldData, useClass: SalesMasterHoldService },
       { provide: SalesPaymentData, useClass: SalesPaymentService },
        { provide: LabTestMethodData, useClass: LabTestMethodService },
     { provide: LabTestMaterialData, useClass: LabTestMaterialService },
     
  { provide: PharmacyIndentData, useClass: PharmacyIndentService },
  { provide: CreditBillReciptMstData, useClass: CreditBillReciptService },
  
  { provide: CollectionReportData, useClass: CollectionReportService },
  { provide: BillServiceWiseReportData, useClass: BillServiceWiseReportService },  

    
  { provide: IpReportData, useClass: IpReportService },
  { provide: SupplierBillMasterData, useClass: SupplierBillService }, 
  //Pharmacy Report
  
  { provide: ProductWiseSalesData, useClass: ProductWiseSalesService },
  { provide: ScheduleHData, useClass: ScheduleHService },
  { provide: PurchaseAbstractData, useClass: PurchaseAbstractService },
  { provide: StockTransactionData, useClass: StockTransactionService },
  { provide: StockUpdateHistoryData, useClass: StockUpdateHistoryService },

  //Asset
  
  {provide: AssetData, useClass:AssetService},

  //Invertory Master Pages by Raja 03-02-2021
  { provide: ItemData, useClass: ItemService },
  { provide: ItemMfrData, useClass: ItemMfrService },
  { provide: ItemCategoryData, useClass: ItemCategoryService },
  { provide: ItemStorageShelfData, useClass: ItemStorageShelfService },
  { provide: ItemTypeData, useClass: ItemTypeService },
  //Invertory Master created by Thenmozhi 03-02-2021
  { provide: CourierMstData, useClass: CourierMstService },
  { provide: WarehouseMstData, useClass: WarehouseMstService },
  { provide: QcReasonMstData, useClass:  QcReasonMstService },
  { provide: SoStatusMstData, useClass:  SoStatusMstService },
  { provide: PoStatusMstData, useClass:  PoStatusMstService },
  { provide: VentilatorPriceSettingsData, useClass: VentilatorPriceSettingsService },

  { provide:ProductModelMstData, useClass: ProductModelMstService },
  { provide:ProductCategoryMstData, useClass: ProductCategoryMstService },
  { provide:ProductSubCategoryMstData, useClass: ProductSubCategoryMstService },
  { provide:CultureMstData, useClass: CultureMstService },
  { provide:ScrapReasonMstData, useClass: ScrapReasonMstService },
   
  { provide:  InventoryPurchaseReturnDetailsData, useClass: InventoryPurchaseReturnDetailsService },
  { provide:  InventoryPurchaseReturnData, useClass: InventoryPurchaseReturnService },
  { provide:  InventoryPurchaseDetailsData, useClass: InventoryPurchaseDetailsService },
  { provide:  InventoryPurchaseData, useClass: InventoryPurchaseService },
  
  //Asset Mst by Santhiya
  { provide: SurgeryData, useClass: SurgeryService },
  { provide: TableData, useClass: TableService },
  { provide: lemMstData, useClass: lemMstService },
  {provide: AssetSubTypeData, useClass:AssetSubTypeService},
  {provide: AssetMstData, useClass:AssetMstService},
  {provide: BloodData, useClass:BloodService},
  {provide: KeyRoleData, useClass:KeyRoleService},
  {provide: IvfDonorMstData, useClass:IvfDonorMstService},
  { provide: VisitModeMstData, useClass: VisitModeMstService }, 
  { provide: BankTransData, useClass: BankTransService },  
  {provide:PatientVaccineSettingsData, useClass:PatientVaccineSettingsService},
  { provide: IpServiceCategoryReportData, useClass: IpServiceCategoryReportService },
  //Lab automation - abirami - 19/3
  {provide:MachineLabTestConfigData, useClass:MachineLabTestConfigService},
  {provide:TATReportData, useClass:TATReportService},   
  
  {provide:AccountsgroupTypeData, useClass:AccountsgroupService},
  {provide:BloodIndentRequestHeaderData, useClass:BloodBankService},
  {provide:BloodIndentRequestDetailsData, useClass:BloodBankService},
  { provide: BloodIndentReturnHeaderData, useClass: BloodBankService },
  { provide: BloodIndentReturnDetailsData, useClass: BloodBankService },
  {provide:GeneralPackageTypeData,useClass:GeneralpackagetypeService},
  {provide:ClinicalAssessmentData,useClass:ClinicalAssessmentService},
  {provide:PatientScoreConfigData,useClass:PatientScoreConfigMstService},
  {provide:NurseHandOverData,useClass:NursehandoverService},
  {provide:ApprovalModuleData,useClass:ApprovalModuleService},
  {provide:VopdData,useClass:VopdService},
  {provide:WhatsappIntegration,useClass:WhatsAppIntegrationService},
  {provide:MailIntegration,useClass:MailIntegrationService},  
   { provide: SellerData, useClass: SellerService },
  { provide: PackageMasterData, useClass: PackageMasterService },
  { provide: DivisionMstData, useClass: DivisionMstService },
  { provide: DivisionDistrictMapData, useClass: DivisionDistrictMapService },
  { provide: HubMstData, useClass: HubMstService },
  { provide: SpokeMstData, useClass: SpokeMstService },
  { provide: UserEntityMappingData, useClass: UserEntityMappingService },

];

@NgModule({
  imports: [CommonModule, NbAuthModule],
})
export class CommonBackendModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: CommonBackendModule,
      providers: [
        ...API,
        ...SERVICES,
      ],
    };
  }
}
